module.exports = __webpack_public_path__ + "static/img/3.c90b4fa1.jpg";